import { FaCheck } from 'react-icons/fa'

export default function Verified({ text, icon, solid }) {
    // solid = true → green pill badge (for "Verified" trust signal)
    // solid = false (default) → minimal inline badge (for usage counts etc.)
    if (solid) {
        return (
            <div className='inline-flex items-center gap-1 bg-green text-white px-2 py-0.5 rounded-full text-xs font-medium'>
                <FaCheck className='text-[8px]' />
                <span>{text}</span>
            </div>
        )
    }
    return (
        <div className='flex items-center gap-1'>
            <div className='bg-primary w-3.5 h-3.5 p-px text-[7px] flex items-center justify-center rounded-full'>
                {icon ? icon : <FaCheck className='text-white' />}
            </div>
            <p className='text-xs'>{text}</p>
        </div>
    )
}